import { DeepLink } from '@/models';
import { apiClient, signedApiClient } from './apiClient';


class DeepLinkService {

  BRANCH_URL: string = '';
  BRANCH_API_KEY: string = '';
  
  initService() {
    this.BRANCH_URL = import.meta.env.VITE_APP_BRANCH_URL;
    this.BRANCH_API_KEY = import.meta.env.VITE_APP_BRANCH_API_KEY;
  }

  async getDeepLink(token: string, studyId?: string, groupId?: string) {
    let uri = '';
    if (studyId) {
      uri = `investigation/${studyId}/link/${token}`;
    } else if (groupId) {
      uri = `group/${groupId}/link/${token}`;
    }
    const signedClient = signedApiClient('GET', uri);
    const linkResponse = await signedClient.get(uri);
    return linkResponse.data;
  }

  async getDeepLinkData(link: string) {
    const uri = `${this.BRANCH_URL}/url?url=${link}&branch_key=${this.BRANCH_API_KEY}`;
    delete apiClient.defaults.headers.common['X-Date'];
    delete apiClient.defaults.headers.common['Authorization'];
    const res = await apiClient.get(uri);
    return DeepLink.mapLink(res.data.data);
  }
}

export default new DeepLinkService;
